import {DropDownMenuComponent} from "@ispm/dashboard/menu/components/drop-down-menu/drop-down-menu.component";
import {Accordion} from 'primeng/accordion';
import {PanelsService} from "@ispm/layout/services/panels.service";
import {ExternalLinksComponent} from "@ispm/dashboard/external-links/external-links.component";
import { FacilityFilterComponent } from "@ispm/dashboard/menu/components/facility-filter/facility-filter.component";

export const SERVICES = [Accordion,PanelsService];
export const COMPONENTS = [DropDownMenuComponent, ExternalLinksComponent,FacilityFilterComponent];
export const COMPONENTS_EXPORTS = [DropDownMenuComponent, ExternalLinksComponent,FacilityFilterComponent];
